﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("RangeVariantApi", [
    "$q",
    "$filter",
    "API",
    "DebugLogger",
    function ($q, $filter, API, DebugLogger) {
      function getById(variantId) {
        return API.get($filter("formatArgs")(ToyotaConsts.API.Vehicle.Variants, [variantId])).then(function (response) {
          if (!response.data.success) {
            DebugLogger.log("RangeVariantApi", "getById: server responded with falsy success");
            throw new Error("RangeVariantApi.getById: server responded with falsy success");
          }

          return response.data;
        });
      }

      return {
        getById: getById,
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
